import { yupResolver } from '@hookform/resolvers/yup';
import { useSelector } from 'react-redux';
import * as Yup from 'yup';
import { projectsSelector } from '../../../../../store';
import { HookFormProvider } from '../../../../UI/HookForm/Provider';
import { ProjectUsesForm } from './ProjectUsesForm';

//Validation Schema needs
const validationSchema = Yup.object({
  uses: Yup.array().of(
    Yup.object({
      name: Yup.string().required('Required'),
      amount: Yup.number().required('Required').min(0, 'Amount must be 0 or greater'),
      source: Yup.string(),
    })
  ),
});

function ProjectUses({ handleProgress }: { handleProgress: (type: string) => void }) {
  const { Project } = useSelector(projectsSelector);
  const ProjectUsesState = Project.ProjectBudget;

  return (
    <HookFormProvider resolver={yupResolver(validationSchema) as any} defaultValues={ProjectUsesState} mode='all'>
      <ProjectUsesForm ProjectUsesState={ProjectUsesState} handleProgress={handleProgress} />
    </HookFormProvider>
  );
}

export default ProjectUses;
